import styled from 'styled-components';
import { device } from '../../../utils/styled-component-mixins';
import ImgWrapper from '../../shared/ImgWrapper';
import ButtonLink from '../../shared/ButtonLinkComponent';

const BioCardStyled = styled.li`
  display: flex;
  margin-bottom: 2.5rem;

  a,
  a:hover,
  a:visited {
    color: inherit;
    display: flex;
    text-decoration: none;

    @media ${device.desktop} {
      flex-direction: column;
      height: 100%;
    }
  }

  > a:hover {
    .btn-icon-tertiary {
      &::after {
        width: 100%;
      }
    }
  }

  @media ${device.desktop} {
    flex-direction: column;
    margin-bottom: 6.7rem;
    text-align: center;
  }

  h3 {
    font-size: 2.2rem;
    font-weight: 800;
    line-height: 3.2rem;
    margin-bottom: 0;

    @media ${device.desktop} {
      margin-top: 1.6rem;
    }
  }

  .bio-title {
    line-height: 2.4rem;
    margin-top: 0;

    @media ${device.desktop} {
      margin-bottom: 1.8rem;
    }
  }

  .img-wrapper {
    flex-basis: 30%;

    img {
      border-radius: 50%;
    }
  }

  .bio-card-info {
    flex-basis: 70%;
    padding-left: 2.4rem;

    @media ${device.desktop} {
      align-items: center;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      padding-left: 0;
    }

    a {
      align-items: center;
      color: var(--button-tertiary);
      display: flex;
      height: 2.6rem;
    }
  }
`;

const BioCard = (props) => {
  const { name, headshot, headshotAltText, jobTitle, url, viewBioText, headingTagNumber } = props;

  return (
    <BioCardStyled>
      <a href={url}>
        <ImgWrapper imageSrc={headshot} imageAlt={headshotAltText} />
        <div className="bio-card-info">
          <div>
            {headingTagNumber === 4 ? <h4>{name}</h4> : <h3>{name}</h3>}
            <p className="bio-title">{jobTitle}</p>
          </div>
          <ButtonLink text={viewBioText} link={url} type="icon-tertiary" icon="person_outline" />
        </div>
      </a>
    </BioCardStyled>
  );
};

BioCard.defaultProps = {
  headingTagNumber: 3
};

export default BioCard;
